export const buildConfigUserPayload = (user = {}) => ({
  nome: user?.nome || '',
  urlRef: user?.urlRef || '',
  emails: Array.isArray(user?.emails) ? user.emails : [],
  filtros: Array.isArray(user?.filtros)
    ? user.filtros.map((filtro = {}) => ({
        nome: filtro?.nome || '',
        tipo: filtro?.tipo || 'SIMPLES',
        prioridade: parseInt(filtro?.prioridade, 10) || 0,
        criteria: {
          inclusao: Array.isArray(filtro?.criteria?.inclusao) ? filtro.criteria.inclusao : [],
          exclusao: Array.isArray(filtro?.criteria?.exclusao) ? filtro.criteria.exclusao : []
        },
        targetColumn: filtro?.targetColumn || null,
        sendSeparateEmail: Boolean(filtro?.sendSeparateEmail),
        outputSection: filtro?.outputSection || ''
      }))
    : [],
  active: user?.active !== undefined ? user.active : true
});

export const buildConfigUserExportPayload = (users = []) =>
  users.map((user) => buildConfigUserPayload(user));

export const parseImportedConfigUsers = (fileText) => {
  const parsed = JSON.parse(fileText);

  if (Array.isArray(parsed)) {
    return parsed;
  }

  if (parsed && typeof parsed === 'object') {
    return [parsed];
  }

  throw new Error('O arquivo precisa ser um objeto JSON válido ou um array de objetos.');
};

export const normalizeImportedConfigUser = (user) => {
  if (!user || typeof user !== 'object') {
    throw new Error('Cada item importado precisa ser um objeto válido.');
  }

  if (!user.nome || typeof user.nome !== 'string' || user.nome.trim() === '') {
    throw new Error('Cada item importado precisa ter um nome.');
  }

  return buildConfigUserPayload(user);
};

export const downloadJsonFile = (payload, filename = 'config-users.json') => {
  const content = JSON.stringify(payload, null, 2);
  const blob = new Blob([content], { type: 'application/json;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
